import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router';
import './Success.scss';
import Configuration from '../../common/Configuration.json';

const SuccessFooter = (props) => {
  const { isUfbReady, isUfbAvailable, hasSubscriptionDiscount, isCovid19Mode, isByoModemSelected } = props;

  const getPaymentBitDescription = () => {
    const descriptionBasedOnDiscountStatus = hasSubscriptionDiscount ? `${Configuration.subscriptionDiscount.durationString} after` : 'on';
    return `We'll start charging your card for your Skinny Broadband ${
       descriptionBasedOnDiscountStatus
       } the day you are first connected. Then you will get charged on the same date, monthly. We'll email you as soon as we have your connection date confirmed (usually within 48 hours).`;
  };
  const getWhatHappenNextMessage = () => {
    if (isUfbReady) {
      return (<div>
        <p>
          {'We’ve just sent you an email to confirm your order, and we’ll flick you another email within the next 48 hours to confirm your connection date.'}
        </p>
        <p>
          {'if you’re transferring from another provider, your broadband should only be down for an hour or so while we set you up.'}
        </p>
        <p className="autotest-success-top-support-link">
          {'If you have any concerns or questions, you can reach us using our '}
          <Link
            className="autotest-footer-navigation-item-contacts"
            to="/contact-us"
            target="_blank"
          >Contact us </Link>
          page.
        </p>
      </div>);
    }

    if (isUfbAvailable && isCovid19Mode) {
      return (<div>
        <p>
          {'We’ve just sent you an email to confirm your order, and we’ll flick you another email within the next 48 hours to confirm the next steps of getting Fibre installed at your place.​​'}
        </p>

        <p className="autotest-success-top-support-link">
          {'We’ll be with you the whole step of the way and if you have any concerns or questions, you can reach us using our '}
          <Link
            className="autotest-footer-navigation-item-contacts"
            to="/contact-us"
            target="_blank"
          >Contact us </Link>
          page.
        </p>
        <p className="autotest-success-top-support-link">
          {'Take a look on how the Fibre installation process will look like on our dedicated '}
          <Link
            className="autotest-footer-navigation-item-contacts"
            to="/support-centre/getting-skinny-unlimited-broadband"
            target="_blank"
          >FAQ page </Link>
          page.
        </p>
      </div>);
    }

    if (isUfbAvailable) {
      return (<div>
        <p>
          {'We’ve just sent you an email to confirm your order, and we’ll flick you another email within the next 48 hours to confirm the next steps of getting Fibre installed at your place.​​'}
        </p>
        <p>
          {'Fibre installs can take 4 – 6 weeks, but sometimes up to 8 weeks although we can organise a temporary ADSL connection for you in the meantime.​'}
        </p>
        <p>
          {'We’ll be with you the whole step of the way and if you have any concerns or questions, you can reach us using our '}
          <Link
            className="autotest-footer-navigation-item-contacts"
            to="/contact-us"
            target="_blank"
          >Contact us </Link>page
        </p>
        <p className="autotest-success-top-support-link">
          {'Take a look on how the Fibre installation process will look like on our dedicated '}
          <Link
            className="autotest-footer-navigation-item-contacts"
            to="/support-centre/getting-skinny-unlimited-broadband"
            target="_blank"
          >FAQ </Link>page.
        </p>
      </div>);
    }
    return (<div>
      <p>
        {'We’ve just sent you an email to confirm your order, and we’ll flick you another email within the next 48 hours to confirm your connection date.'}
      </p>
      <p>
        {`Unless you’ve asked for a later connection date,
        it will take around 3 - 7 working days to get connected.
        Our aim is to get you connected on your preferred connection date
        but we’ll let you know as soon as possible if there are any delays.`}
      </p>
      <p>
        {`If you’re transferring from another provider,
        your broadband should only be down for an hour or so while we set you up.`}
      </p>
      <p className="autotest-success-top-support-link">
        {'If you have any concerns or questions, you can reach us using our '}
        <Link
          className="autotest-footer-navigation-item-contacts"
          to="/contact-us"
          target="_blank"
        >Contact us </Link>
          page.
      </p>
    </div>);
  };

  return (
    <section className="success-footer">
      <div className="container">
        <div className="row">
          <div className="col-sm-10">
            <h3 className="success-section-heading">What happens next?</h3>
            {getWhatHappenNextMessage()}
          </div>
        </div>
        {!isByoModemSelected && <div className="row">
          <div className="col-sm-10">
            <h3 className="success-section-heading">Setting up your modem</h3>
            <p>
            It&apos;s super easy. There will be instructions on the modem itself when you get it in the post.
            </p>
          </div>
        </div>}
        <div className="row">
          <div className="col-sm-10">
            <h3 className="success-section-heading">How the payment bit works</h3>
            {getPaymentBitDescription()}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-10">
            <h3 className="success-section-heading">Terms & conditions</h3>
            <p className="autotest-success-terms-conditions-link">
            Want to have a good squizz at these? You can check them
              <a href="https://www.skinny.co.nz/skinny-terms/" target="_blank" rel="noopener noreferrer"> here</a>.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-10">
            <h3 className="success-section-heading">Something not quite right?</h3>
            <p className="autotest-success-bottom-support-link">
            Is the above info not what you&apos;re wanting? Flick us an
              <Link
                className="autotest-footer-navigation-item-email"
                to="/contact-us"
                target="_blank"
              > email </Link>
            or give us a ring on 0800 4 SKINNY (0800 475 4669). Our call centre hours are Monday - Friday
            (8am - 7pm) and Saturday, Sunday and all public holidays (9am - 5pm).
            </p>
          </div>
        </div>
      </div>
    </section>

  );
};
SuccessFooter.propTypes = {
  hasSubscriptionDiscount: PropTypes.bool.isRequired,
  isUfbAvailable: PropTypes.bool,
  isUfbReady: PropTypes.bool,
  isCovid19Mode: PropTypes.bool,
  isByoModemSelected: PropTypes.bool
};

export default SuccessFooter;



/** WEBPACK FOOTER **
 ** ./src/components/Success/SuccessFooter.js
 **/